<template>
  <a :href="url" target="_self" class="hl-link">
	<slot></slot>
  </a>
</template>

<script>
export default {
	props: {
		url: {
			type: String,
			default: "#"
		}
	}
}
</script>

<style lang="scss">
	.hl-link {
		color: $navyBlue;
		border: none;
		border-bottom: 1px solid $orangeLines;
		text-decoration: none;
		padding-bottom: 0.0rem;
		padding-right: 2.5rem;
		display: inline-block;
		margin-bottom: 0.5rem;
		transition: all 0.15s;
		&:hover {
			color: $darkOrangeText;
			text-decoration: none;
			border-bottom-color: $darkOrangeText;

			// idea: Line moves away from link - but line would have to be done with :after
			// border-bottom: 1px solid rgba(255,255,255,1);
		}
	}

	.background-is-light {
		.hl-link {
			&:hover {
				color: $black;

				border-bottom: 1px solid darken($orangeLines, 20%);
			}
		}
	}

	.background-is-navy, .background-is-navy-transp, {
		.hl-link {
			&:hover {
				color: $orangeText;
			}
		}
	}
</style>
